module.exports = __webpack_public_path__ + "media/img/paygold/waiting-1a6723c3757bffab0554f7043be1a4c1.gif";